import { Injectable } from '@angular/core';
import { IBookingCostValidationResult } from '@core/booking/models/booking-cost-validation-result.model';
import { IDiscounts } from '@core/discounts/models/discounts.model';
import { IGiftcardCanDeduct } from '@core/gift-card/gift-card-can-deduct.model';
import { CRouteList } from '@app/route-list.const';
import { IAutomaticDiscount } from '../automatic-discount/automatic-discount.model';

@Injectable({
  providedIn: 'root'
})
export class OrderDiscountService {
  getCostValidDiscounts(
    dto: IBookingCostValidationResult,
    discounts: IDiscounts[] = [],
    automaticDiscount?: IAutomaticDiscount
  ): IDiscounts[] {
    if (!dto.discounts?.length) {
      return [];
    }

    const memberCodes = discounts.filter((m) => m.discountType === 'membership').map((m) => m.code);

    // We are re-checking applied discounts, so remove any that have become invalid
    return dto.discounts.map((dResult: IDiscounts) => {
      const isMembership = memberCodes.some((key: string) => key === dResult.code);
      return isMembership
        ? { ...dResult, discountType: 'membership' }
        : {
            ...dResult,
            discountType: 'discount',
            isAutomaticDiscount: dResult.code === automaticDiscount?.code
          };
    });
  }

  /** Ensure only valid gift cards are applied, and update the amount deducted using DTO result i.e. a discount or another GC is applied changing the previous amount  */
  getCostValidGiftCards(dto: IBookingCostValidationResult, giftCards: IGiftcardCanDeduct[] = []): IGiftcardCanDeduct[] {
    if (!dto.giftCards?.length || !!dto.giftCardErrors?.length) {
      return [];
    }

    const validGiftCards: IGiftcardCanDeduct[] = [];
    giftCards.forEach((gc) => {
      const validated = dto.giftCards?.find((g) => g.giftcardNumber === gc.giftcardNumber);
      if (!validated) {
        return;
      }

      validGiftCards.push({ ...gc, amountDeducted: validated.amountDeducted });
    });

    return validGiftCards;
  }

  /** Order discounts will only be displayed and costed on these routes */
  getDiscountVisibleRoutes(): string[] {
    return [
      CRouteList.details,
      CRouteList.payment,
      CRouteList.confirmation,
      CRouteList.agreement,
      CRouteList.waiver,
      CRouteList.waiverShare
    ];
  }
}
